import React from 'react'
import { get } from 'lodash'
import css from './card.module.scss'

const MeetingRoomCard = ({ name, availability, selectMeetingRoom, capacity, space }) => {
  const image = get(space, 'assets[0].url')
  return (
    <div className={css.employeeCard} onClick={selectMeetingRoom}>
      <div className={css.icon}>
        <img src={image || '/public/meeting-room-placeholder.png'} />
      </div>
      <div className={css.text}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className={`${css.large} ${css.ellipsis}`}>
            {availability === 'available' && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="meeting-room-available">Meeting room is available.</Tooltip>}
              >
                <i className="fa fa-check-circle" style={{ color: 'rgb(81, 177, 73)' }} />
              </OverlayTrigger>
            )}
            {availability === 'unavailable' && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="meeting-room-used">Meeting room is in use.</Tooltip>}
              >
                <i className="fa fa-exclamation-circle" style={{ color: '#8a6d3b' }} />
              </OverlayTrigger>
            )}
            {name}
          </div>
          <div className={css.small}>{Boolean(capacity) && <span>capacity: {capacity}</span>}</div>
        </div>
      </div>
    </div>
  )
}

export default MeetingRoomCard
